@if (isLoading || recipeOverview) {
  <sd-recipe-overview
    [brand]="brand"
    [recipeOverview]="recipeOverview"
    [isReworked]="isReworked"
    [isLoading]="isLoading"
    (printClicked)="onPrintClick()"
    (reviewsClicked)="onReviewsClicked($event)"
    (deviceIsClicked)="onDeviceClick($event)"
    (devicePushIsClicked)="onDevicePushClick()"
    (updateValue)="onUpdateValue($event)"
  />
}
